const countriesEn = [
    {
        "en": "Afghanistan",
        "code": "AF",
        "code3": "AFG"
    },
    {
        "en": "Albania",
        "code": "AL",
        "code3": "ALB"
    },
    {
        "en": "Algeria",
        "code": "DZ",
        "code3": "DZA"
    },
    {
        "en": "American Samoa",
        "code": "AS",
        "code3": "ASM"
    },
    {
        "en": "Andorra",
        "code": "AD",
        "code3": "AND"
    },
    {
        "en": "Angola",
        "code": "AO",
        "code3": "AGO"
    },
    {
        "en": "Anguilla",
        "code": "AI",
        "code3": "AIA"
    },
    {
        "en": "Antarctica",
        "code": "AQ",
        "code3": "ATA"
    },
    {
        "en": "Antigua and Barbuda",
        "code": "AG",
        "code3": "ATG"
    },
    {
        "en": "Argentina",
        "code": "AR",
        "code3": "ARG"
    },
    {
        "en": "Armenia",
        "code": "AM",
        "code3": "ARM"
    },
    {
        "en": "Aruba",
        "code": "AW",
        "code3": "ABW"
    },
    {
        "en": "Australia",
        "code": "AU",
        "code3": "AUS"
    },
    {
        "en": "Austria",
        "code": "AT",
        "code3": "AUT"
    },
    {
        "en": "Azerbaijan",
        "code": "AZ",
        "code3": "AZE"
    },
    {
        "en": "Bahamas (the)",
        "code": "BS",
        "code3": "BHS"
    },
    {
        "en": "Bahrain",
        "code": "BH",
        "code3": "BHR"
    },
    {
        "en": "Bangladesh",
        "code": "BD",
        "code3": "BGD"
    },
    {
        "en": "Barbados",
        "code": "BB",
        "code3": "BRB"
    },
    {
        "en": "Belarus",
        "code": "BY",
        "code3": "BLR"
    },
    {
        "en": "Belgium",
        "code": "BE",
        "code3": "BEL"
    },
    {
        "en": "Belize",
        "code": "BZ",
        "code3": "BLZ"
    },
    {
        "en": "Benin",
        "code": "BJ",
        "code3": "BEN"
    },
    {
        "en": "Bermuda",
        "code": "BM",
        "code3": "BMU"
    },
    {
        "en": "Bhutan",
        "code": "BT",
        "code3": "BTN"
    },
    {
        "en": "Bolivia (Plurinational State of)",
        "code": "BO",
        "code3": "BOL"
    },
    {
        "en": "Bosnia and Herzegovina",
        "code": "BA",
        "code3": "BIH"
    },
    {
        "en": "Botswana",
        "code": "BW",
        "code3": "BWA"
    },
    {
        "en": "Bouvet Island",
        "code": "BV",
        "code3": "BVT"
    },
    {
        "en": "Brazil",
        "code": "BR",
        "code3": "BRA"
    },
    {
        "en": "British Indian Ocean Territory (the)",
        "code": "IO",
        "code3": "IOT"
    },
    {
        "en": "Brunei Darussalam",
        "code": "BN",
        "code3": "BRN"
    },
    {
        "en": "Burkina Faso",
        "code": "BF",
        "code3": "BFA"
    },
    {
        "en": "Burundi",
        "code": "BI",
        "code3": "BDI"
    },
    {
        "en": "Cabo Verde",
        "code": "CV",
        "code3": "CPV"
    },
    {
        "en": "Cambodia",
        "code": "KH",
        "code3": "KHM"
    },
    {
        "en": "Cameroon",
        "code": "CM",
        "code3": "CMR"
    },
    {
        "en": "Canada",
        "code": "CA",
        "code3": "CAN"
    },
    {
        "en": "Cayman Islands (the)",
        "code": "KY",
        "code3": "CYM"
    },
    {
        "en": "Central African Republic (the)",
        "code": "CF",
        "code3": "CAF"
    },
    {
        "en": "Chad",
        "code": "TD",
        "code3": "TCD"
    },
    {
        "en": "Chile",
        "code": "CL",
        "code3": "CHL"
    },
    {
        "en": "China",
        "code": "CN",
        "code3": "CHN"
    },
    {
        "en": "Christmas Island",
        "code": "CX",
        "code3": "CXR"
    },
    {
        "en": "Cocos (Keeling) Islands (the)",
        "code": "CC",
        "code3": "CCK"
    },
    {
        "en": "Colombia",
        "code": "CO",
        "code3": "COL"
    },
    {
        "en": "Comoros (the)",
        "code": "KM",
        "code3": "COM"
    },
    {
        "en": "Congo (the Democratic Republic of the)",
        "code": "CD",
        "code3": "COD"
    },
    {
        "en": "Congo (the)",
        "code": "CG",
        "code3": "COG"
    },
    {
        "en": "Cook Islands (the)",
        "code": "CK",
        "code3": "COK"
    },
    {
        "en": "Costa Rica",
        "code": "CR",
        "code3": "CRI"
    },
    {
        "en": "Croatia",
        "code": "HR",
        "code3": "HRV"
    },
    {
        "en": "Cuba",
        "code": "CU",
        "code3": "CUB"
    },
    {
        "en": "Curaçao",
        "code": "CW",
        "code3": "CUW"
    },
    {
        "en": "Cyprus",
        "code": "CY",
        "code3": "CYP"
    },
    {
        "en": "Czechia",
        "code": "CZ",
        "code3": "CZE"
    },
    {
        "en": "Côte d'Ivoire",
        "code": "CI",
        "code3": "CIV"
    },
    {
        "en": "Denmark",
        "code": "DK",
        "code3": "DNK"
    },
    {
        "en": "Djibouti",
        "code": "DJ",
        "code3": "DJI"
    },
    {
        "en": "Dominica",
        "code": "DM",
        "code3": "DMA"
    },
    {
        "en": "Dominican Republic (the)",
        "code": "DO",
        "code3": "DOM"
    },
    {
        "en": "Ecuador",
        "code": "EC",
        "code3": "ECU"
    },
    {
        "en": "Egypt",
        "code": "EG",
        "code3": "EGY"
    },
    {
        "en": "El Salvador",
        "code": "SV",
        "code3": "SLV"
    },
    {
        "en": "Equatorial Guinea",
        "code": "GQ",
        "code3": "GNQ"
    },
    {
        "en": "Eritrea",
        "code": "ER",
        "code3": "ERI"
    },
    {
        "en": "Estonia",
        "code": "EE",
        "code3": "EST"
    },
    {
        "en": "Eswatini",
        "code": "SZ",
        "code3": "SWZ"
    },
    {
        "en": "Ethiopia",
        "code": "ET",
        "code3": "ETH"
    },
    {
        "en": "Falkland Islands (the) [Malvinas]",
        "code": "FK",
        "code3": "FLK"
    },
    {
        "en": "Faroe Islands (the)",
        "code": "FO",
        "code3": "FRO"
    },
    {
        "en": "Fiji",
        "code": "FJ",
        "code3": "FJI"
    },
    {
        "en": "Finland",
        "code": "FI",
        "code3": "FIN"
    },
    {
        "en": "France",
        "code": "FR",
        "code3": "FRA"
    },
    {
        "en": "French Guiana",
        "code": "GF",
        "code3": "GUF"
    },
    {
        "en": "French Polynesia",
        "code": "PF",
        "code3": "PYF"
    },
    {
        "en": "French Southern Territories (the)",
        "code": "TF",
        "code3": "ATF"
    },
    {
        "en": "Gabon",
        "code": "GA",
        "code3": "GAB"
    },
    {
        "en": "Gambia (the)",
        "code": "GM",
        "code3": "GMB"
    },
    {
        "en": "Georgia",
        "code": "GE",
        "code3": "GEO"
    },
    {
        "en": "Germany",
        "code": "DE",
        "code3": "DEU"
    },
    {
        "en": "Ghana",
        "code": "GH",
        "code3": "GHA"
    },
    {
        "en": "Gibraltar",
        "code": "GI",
        "code3": "GIB"
    },
    {
        "en": "Greece",
        "code": "GR",
        "code3": "GRC"
    },
    {
        "en": "Greenland",
        "code": "GL",
        "code3": "GRL"
    },
    {
        "en": "Grenada",
        "code": "GD",
        "code3": "GRD"
    },
    {
        "en": "Guadeloupe",
        "code": "GP",
        "code3": "GLP"
    },
    {
        "en": "Guam",
        "code": "GU",
        "code3": "GUM"
    },
    {
        "en": "Guatemala",
        "code": "GT",
        "code3": "GTM"
    },
    {
        "en": "Guernsey",
        "code": "GG",
        "code3": "GGY"
    },
    {
        "en": "Guinea",
        "code": "GN",
        "code3": "GIN"
    },
    {
        "en": "Guinea-Bissau",
        "code": "GW",
        "code3": "GNB"
    },
    {
        "en": "Guyana",
        "code": "GY",
        "code3": "GUY"
    },
    {
        "en": "Haiti",
        "code": "HT",
        "code3": "HTI"
    },
    {
        "en": "Heard Island and McDonald Islands",
        "code": "HM",
        "code3": "HMD"
    },
    {
        "en": "Holy See (the)",
        "code": "VA",
        "code3": "VAT"
    },
    {
        "en": "Honduras",
        "code": "HN",
        "code3": "HND"
    },
    {
        "en": "Hong Kong",
        "code": "HK",
        "code3": "HKG"
    },
    {
        "en": "Hungary",
        "code": "HU",
        "code3": "HUN"
    },
    {
        "en": "Iceland",
        "code": "IS",
        "code3": "ISL"
    },
    {
        "en": "India",
        "code": "IN",
        "code3": "IND"
    },
    {
        "en": "Indonesia",
        "code": "ID",
        "code3": "IDN"
    },
    {
        "en": "Iran (Islamic Republic of)",
        "code": "IR",
        "code3": "IRN"
    },
    {
        "en": "Iraq",
        "code": "IQ",
        "code3": "IRQ"
    },
    {
        "en": "Ireland",
        "code": "IE",
        "code3": "IRL"
    },
    {
        "en": "Isle of Man",
        "code": "IM",
        "code3": "IMN"
    },
    {
        "en": "Israel",
        "code": "IL",
        "code3": "ISR"
    },
    {
        "en": "Italy",
        "code": "IT",
        "code3": "ITA"
    },
    {
        "en": "Jamaica",
        "code": "JM",
        "code3": "JAM"
    },
    {
        "en": "Japan",
        "code": "JP",
        "code3": "JPN"
    },
    {
        "en": "Jersey",
        "code": "JE",
        "code3": "JEY"
    },
    {
        "en": "Jordan",
        "code": "JO",
        "code3": "JOR"
    },
    {
        "en": "Kazakhstan",
        "code": "KZ",
        "code3": "KAZ"
    },
    {
        "en": "Kenya",
        "code": "KE",
        "code3": "KEN"
    },
    {
        "en": "Kiribati",
        "code": "KI",
        "code3": "KIR"
    },
    {
        "en": "Korea (the Democratic People's Republic of)",
        "code": "KP",
        "code3": "PRK"
    },
    {
        "en": "Korea (the Republic of)",
        "code": "KR",
        "code3": "KOR"
    },
    {
        "en": "Kuwait",
        "code": "KW",
        "code3": "KWT"
    },
    {
        "en": "Kyrgyzstan",
        "code": "KG",
        "code3": "KGZ"
    },
    {
        "en": "Lao People's Democratic Republic (the)",
        "code": "LA",
        "code3": "LAO"
    },
    {
        "en": "Latvia",
        "code": "LV",
        "code3": "LVA"
    },
    {
        "en": "Lebanon",
        "code": "LB",
        "code3": "LBN"
    },
    {
        "en": "Lesotho",
        "code": "LS",
        "code3": "LSO"
    },
    {
        "en": "Liberia",
        "code": "LR",
        "code3": "LBR"
    },
    {
        "en": "Libya",
        "code": "LY",
        "code3": "LBY"
    },
    {
        "en": "Liechtenstein",
        "code": "LI",
        "code3": "LIE"
    },
    {
        "en": "Lithuania",
        "code": "LT",
        "code3": "LTU"
    },
    {
        "en": "Luxembourg",
        "code": "LU",
        "code3": "LUX"
    },
    {
        "en": "Macao",
        "code": "MO",
        "code3": "MAC"
    },
    {
        "en": "Madagascar",
        "code": "MG",
        "code3": "MDG"
    },
    {
        "en": "Malawi",
        "code": "MW",
        "code3": "MWI"
    },
    {
        "en": "Malaysia",
        "code": "MY",
        "code3": "MYS"
    },
    {
        "en": "Maldives",
        "code": "MV",
        "code3": "MDV"
    },
    {
        "en": "Mali",
        "code": "ML",
        "code3": "MLI"
    },
    {
        "en": "Malta",
        "code": "MT",
        "code3": "MLT"
    },
    {
        "en": "Marshall Islands (the)",
        "code": "MH",
        "code3": "MHL"
    },
    {
        "en": "Martinique",
        "code": "MQ",
        "code3": "MTQ"
    },
    {
        "en": "Mauritania",
        "code": "MR",
        "code3": "MRT"
    },
    {
        "en": "Mauritius",
        "code": "MU",
        "code3": "MUS"
    },
    {
        "en": "Mayotte",
        "code": "YT",
        "code3": "MYT"
    },
    {
        "en": "Mexico",
        "code": "MX",
        "code3": "MEX"
    },
    {
        "en": "Micronesia (Federated States of)",
        "code": "FM",
        "code3": "FSM"
    },
    {
        "en": "Moldova (the Republic of)",
        "code": "MD",
        "code3": "MDA"
    },
    {
        "en": "Monaco",
        "code": "MC",
        "code3": "MCO"
    },
    {
        "en": "Mongolia",
        "code": "MN",
        "code3": "MNG"
    },
    {
        "en": "Montenegro",
        "code": "ME",
        "code3": "MNE"
    },
    {
        "en": "Montserrat",
        "code": "MS",
        "code3": "MSR"
    },
    {
        "en": "Morocco",
        "code": "MA",
        "code3": "MAR"
    },
    {
        "en": "Mozambique",
        "code": "MZ",
        "code3": "MOZ"
    },
    {
        "en": "Myanmar",
        "code": "MM",
        "code3": "MMR"
    },
    {
        "en": "Namibia",
        "code": "NA",
        "code3": "NAM"
    },
    {
        "en": "Nauru",
        "code": "NR",
        "code3": "NRU"
    },
    {
        "en": "Nepal",
        "code": "NP",
        "code3": "NPL"
    },
    {
        "en": "Netherlands (Kingdom of the)",
        "code": "NL",
        "code3": "NLD"
    },
    {
        "en": "New Caledonia",
        "code": "NC",
        "code3": "NCL"
    },
    {
        "en": "New Zealand",
        "code": "NZ",
        "code3": "NZL"
    },
    {
        "en": "Nicaragua",
        "code": "NI",
        "code3": "NIC"
    },
    {
        "en": "Niger (the)",
        "code": "NE",
        "code3": "NER"
    },
    {
        "en": "Nigeria",
        "code": "NG",
        "code3": "NGA"
    },
    {
        "en": "Niue",
        "code": "NU",
        "code3": "NIU"
    },
    {
        "en": "Norfolk Island",
        "code": "NF",
        "code3": "NFK"
    },
    {
        "en": "North Macedonia",
        "code": "MK",
        "code3": "MKD"
    },
    {
        "en": "Northern Mariana Islands (the)",
        "code": "MP",
        "code3": "MNP"
    },
    {
        "en": "Norway",
        "code": "NO",
        "code3": "NOR"
    },
    {
        "en": "Oman",
        "code": "OM",
        "code3": "OMN"
    },
    {
        "en": "Pakistan",
        "code": "PK",
        "code3": "PAK"
    },
    {
        "en": "Palau",
        "code": "PW",
        "code3": "PLW"
    },
    {
        "en": "Palestine, State of",
        "code": "PS",
        "code3": "PSE"
    },
    {
        "en": "Panama",
        "code": "PA",
        "code3": "PAN"
    },
    {
        "en": "Papua New Guinea",
        "code": "PG",
        "code3": "PNG"
    },
    {
        "en": "Paraguay",
        "code": "PY",
        "code3": "PRY"
    },
    {
        "en": "Peru",
        "code": "PE",
        "code3": "PER"
    },
    {
        "en": "Philippines (the)",
        "code": "PH",
        "code3": "PHL"
    },
    {
        "en": "Pitcairn",
        "code": "PN",
        "code3": "PCN"
    },
    {
        "en": "Poland",
        "code": "PL",
        "code3": "POL"
    },
    {
        "en": "Portugal",
        "code": "PT",
        "code3": "PRT"
    },
    {
        "en": "Puerto Rico",
        "code": "PR",
        "code3": "PRI"
    },
    {
        "en": "Qatar",
        "code": "QA",
        "code3": "QAT"
    },
    {
        "en": "Romania",
        "code": "RO",
        "code3": "ROU"
    },
    {
        "en": "Russian Federation (the)",
        "code": "RU",
        "code3": "RUS"
    },
    {
        "en": "Rwanda",
        "code": "RW",
        "code3": "RWA"
    },
    {
        "en": "Réunion",
        "code": "RE",
        "code3": "REU"
    },
    {
        "en": "Saint Barthélemy",
        "code": "BL",
        "code3": "BLM"
    },
    {
        "en": "Saint Helena, Ascension and Tristan da Cunha",
        "code": "SH",
        "code3": "SHN"
    },
    {
        "en": "Saint Kitts and Nevis",
        "code": "KN",
        "code3": "KNA"
    },
    {
        "en": "Saint Lucia",
        "code": "LC",
        "code3": "LCA"
    },
    {
        "en": "Saint Martin (French part)",
        "code": "MF",
        "code3": "MAF"
    },
    {
        "en": "Saint Pierre and Miquelon",
        "code": "PM",
        "code3": "SPM"
    },
    {
        "en": "Saint Vincent and the Grenadines",
        "code": "VC",
        "code3": "VCT"
    },
    {
        "en": "Samoa",
        "code": "WS",
        "code3": "WSM"
    },
    {
        "en": "San Marino",
        "code": "SM",
        "code3": "SMR"
    },
    {
        "en": "Sao Tome and Principe",
        "code": "ST",
        "code3": "STP"
    },
    {
        "en": "Saudi Arabia",
        "code": "SA",
        "code3": "SAU"
    },
    {
        "en": "Senegal",
        "code": "SN",
        "code3": "SEN"
    },
    {
        "en": "Seychelles",
        "code": "SC",
        "code3": "SYC"
    },
    {
        "en": "Sierra Leone",
        "code": "SL",
        "code3": "SLE"
    },
    {
        "en": "Singapore",
        "code": "SG",
        "code3": "SGP"
    },
    {
        "en": "Sint Maarten (Dutch part)",
        "code": "SX",
        "code3": "SXM"
    },
    {
        "en": "Slovakia",
        "code": "SK",
        "code3": "SVK"
    },
    {
        "en": "Slovenia",
        "code": "SI",
        "code3": "SVN"
    },
    {
        "en": "Solomon Islands",
        "code": "SB",
        "code3": "SLB"
    },
    {
        "en": "Somalia",
        "code": "SO",
        "code3": "SOM"
    },
    {
        "en": "South Africa",
        "code": "ZA",
        "code3": "ZAF"
    },
    {
        "en": "South Georgia and the South Sandwich Islands",
        "code": "GS",
        "code3": "SGS"
    },
    {
        "en": "South Sudan",
        "code": "SS",
        "code3": "SSD"
    },
    {
        "en": "Spain",
        "code": "ES",
        "code3": "ESP"
    },
    {
        "en": "Sri Lanka",
        "code": "LK",
        "code3": "LKA"
    },
    {
        "en": "Sudan (the)",
        "code": "SD",
        "code3": "SDN"
    },
    {
        "en": "Suriname",
        "code": "SR",
        "code3": "SUR"
    },
    {
        "en": "Svalbard and Jan Mayen",
        "code": "SJ",
        "code3": "SJM"
    },
    {
        "en": "Sweden",
        "code": "SE",
        "code3": "SWE"
    },
    {
        "en": "Switzerland",
        "code": "CH",
        "code3": "CHE"
    },
    {
        "en": "Syrian Arab Republic (the)",
        "code": "SY",
        "code3": "SYR"
    },
    {
        "en": "Taiwan (Province of China)",
        "code": "TW",
        "code3": "TWN"
    },
    {
        "en": "Tajikistan",
        "code": "TJ",
        "code3": "TJK"
    },
    {
        "en": "Tanzania, the United Republic of",
        "code": "TZ",
        "code3": "TZA"
    },
    {
        "en": "Thailand",
        "code": "TH",
        "code3": "THA"
    },
    {
        "en": "Timor-Leste",
        "code": "TL",
        "code3": "TLS"
    },
    {
        "en": "Togo",
        "code": "TG",
        "code3": "TGO"
    },
    {
        "en": "Tokelau",
        "code": "TK",
        "code3": "TKL"
    },
    {
        "en": "Tonga",
        "code": "TO",
        "code3": "TON"
    },
    {
        "en": "Trinidad and Tobago",
        "code": "TT",
        "code3": "TTO"
    },
    {
        "en": "Tunisia",
        "code": "TN",
        "code3": "TUN"
    },
    {
        "en": "Turkmenistan",
        "code": "TM",
        "code3": "TKM"
    },
    {
        "en": "Turks and Caicos Islands (the)",
        "code": "TC",
        "code3": "TCA"
    },
    {
        "en": "Tuvalu",
        "code": "TV",
        "code3": "TUV"
    },
    {
        "en": "Türkiye",
        "code": "TR",
        "code3": "TUR"
    },
    {
        "en": "Uganda",
        "code": "UG",
        "code3": "UGA"
    },
    {
        "en": "Ukraine",
        "code": "UA",
        "code3": "UKR"
    },
    {
        "en": "United Arab Emirates (the)",
        "code": "AE",
        "code3": "ARE"
    },
    {
        "en": "United Kingdom of Great Britain and Northern Ireland (the)",
        "code": "GB",
        "code3": "GBR"
    },
    {
        "en": "United States Minor Outlying Islands (the)",
        "code": "UM",
        "code3": "UMI"
    },
    {
        "en": "United States of America (the)",
        "code": "US",
        "code3": "USA"
    },
    {
        "en": "Uruguay",
        "code": "UY",
        "code3": "URY"
    },
    {
        "en": "Uzbekistan",
        "code": "UZ",
        "code3": "UZB"
    },
    {
        "en": "Vanuatu",
        "code": "VU",
        "code3": "VUT"
    },
    {
        "en": "Venezuela (Bolivarian Republic of)",
        "code": "VE",
        "code3": "VEN"
    },
    {
        "en": "Viet Nam",
        "code": "VN",
        "code3": "VNM"
    },
    {
        "en": "Virgin Islands (British)",
        "code": "VG",
        "code3": "VGB"
    },
    {
        "en": "Virgin Islands (U.S.)",
        "code": "VI",
        "code3": "VIR"
    },
    {
        "en": "Wallis and Futuna",
        "code": "WF",
        "code3": "WLF"
    },
];

export default countriesEn;